import Typography from "@mui/material/Typography";
import RadioField from "shared/form/RadioField";
import BoxContent from "shared/ui/BoxContent";
import Loading from "shared/ui/Loading";

const GradeSelect = ({loading, errors, grade, grades, setGradeHandler}: any) => {
    return (
        <>
            <Typography variant="h3" mb={3} mt={3}>
                Alege clasa
            </Typography>
            <BoxContent>
                {loading.loading && loading.name === "grade" ? (
                    <Loading show={true}/>
                ) : (
                    <RadioField
                        row={true}
                        name="grade"
                        columns={true}
                        defaultValue={grade}
                        onChange={setGradeHandler}
                        options={grades.map((item: { name: string; id: string }) => {
                            return {
                                label: item.name,
                                value: item.id.toString(),
                                ...item,
                            };
                        })}
                        error={errors.grade?.message}
                    />
                )}
            </BoxContent>
        </>
    );
};

export default GradeSelect;
